"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RitualHours() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="351" id="ritual-hours" className="bg-background text-foreground relative overflow-hidden py-20 md:py-28 lg:py-32">
      <div aria-hidden="true" className="pointer-events-none absolute bottom-0 right-0 opacity-[0.04] select-none">
        <svg width="420" height="420" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 20 Q100 100 100 180" stroke="currentColor" strokeWidth="2" className="text-primary" />
          <ellipse cx="100" cy="40" rx="6" ry="14" fill="currentColor" className="text-primary" />
          <ellipse cx="88" cy="55" rx="5" ry="12" fill="currentColor" className="text-primary" transform="rotate(-25 88 55)" />
          <ellipse cx="112" cy="55" rx="5" ry="12" fill="currentColor" className="text-primary" transform="rotate(25 112 55)" />
          <ellipse cx="85" cy="80" rx="5" ry="12" fill="currentColor" className="text-primary" transform="rotate(-25 85 80)" />
          <ellipse cx="115" cy="80" rx="5" ry="12" fill="currentColor" className="text-primary" transform="rotate(25 115 80)" />
          <ellipse cx="82" cy="105" rx="5" ry="12" fill="currentColor" className="text-primary" transform="rotate(-25 82 105)" />
          <ellipse cx="118" cy="105" rx="5" ry="12" fill="currentColor" className="text-primary" transform="rotate(25 118 105)" />
          <ellipse cx="80" cy="130" rx="5" ry="12" fill="currentColor" className="text-primary" transform="rotate(-25 80 130)" />
          <ellipse cx="120" cy="130" rx="5" ry="12" fill="currentColor" className="text-primary" transform="rotate(25 120 130)" />
        </svg>
      </div>

      <div ref={ref} className={`relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="max-w-3xl">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-primary mb-6">
            —— 03 / Studio Rituals
          </p>
        </div>
      </div>

      <div className="relative mt-20 md:mt-24 border-y border-border py-5 overflow-hidden">
        <div className="flex whitespace-nowrap animate-marquee">
          {Array.from({
          length: 8
        }).map((_, i) => <div key={i} data-index={i} className="flex items-center font-mono text-sm uppercase tracking-[0.25em] text-muted-foreground">
              <span className="px-6">Hard Rock Tattoo</span>
              <span className="text-primary">·</span>
              <span className="px-6">Paphos Cyprus</span>
              <span className="text-primary">·</span>
              <span className="px-6">Ink Legend</span>
              <span className="text-primary px-6">·</span>
            </div>)}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
          width: max-content;
        }
      `}</style>
    </section>;
}